import Joi from "joi";
import { CountersDTO } from "../Counter/CountersDTO";

export interface StartAndEndExecutionDTO {
    executionStart: Date;
    executionEnd: Date;
    assistanceId: number;
    technicianId: string;
    pending: string;
    workDone: string | null;
    counters?: CountersDTO[];
    startLocationLat?: number | null;
    startLocationLon?: number | null;
    endLocationLat?: number | null;
    endLocationLon?: number | null;
}

export const StartAndEndExecutionDTOSchema = Joi.object({
    technicianId: Joi.string()
        .required()
        .messages({ "string.empty": "Técnico deve de estar selecionado" }),
    executionStart: Joi.date().messages({ "date.base": "Data de início deve de estar preenchida" }),
    executionEnd: Joi.date().messages({ "date.base": "Data de fim deve de estar preenchida" }),
    workDone: Joi.string()
        .required()
        .messages({ "string.empty": "Trabalho Efetuado deve estar preenchido" }),
    pending: Joi.string()
        .allow('')
        .optional(),
});
